import React, { Component } from 'react';
import { InlineEdit } from '@cimpress/react-components';

export default class InlineEditDemo extends Component {
  state = {
    activeChangeValue: 'Play around with this text',
    normalValue: '',
    requiredValue: 'See what happens when you empty this field',
    sizeValue: 'I come in multiple sizes!',
    validationValue: 'See what happens when you validate',
  };

  handleSuccess = ({ value, name }) => {
    this.setState({ [name]: value });
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  validateText = text => {
    if (text.toLowerCase() === 'test') {
      return 'Told you not to enter test';
    }

    return null;
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-6">
            <InlineEdit
              name="normalValue"
              placeholder="No need for a label here."
              value={this.state.normalValue}
              onSave={this.handleSuccess}
            />
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6">
                <InlineEdit
                  name="activeChangeValue"
                  placeholder="Add a description"
                  label="Description"
                  value={this.state.activeChangeValue}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-md-6">
                <p style={{ wordBreak: 'break-all' }}>{this.state.activeChangeValue}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <InlineEdit
              name="requiredValue"
              placeholder={"It's dangerous to go alone."}
              label="Take This"
              value={this.state.requiredValue}
              onSave={this.handleSuccess}
              required
            />
          </div>
          <div className="col-md-6">
            <InlineEdit
              name="disabledValue"
              placeholder={"It's dangerous to go alone."}
              label="This field is disabled!"
              value="Have you tried turning it off and on again?"
              onSave={this.handleSuccess}
              disabled
            />
          </div>
          <div className="col-md-6">
            <InlineEdit
              name="textareaValue"
              placeholder="Enter some very long text"
              label="This uses a textarea"
              value="Ok, but what if you have some really long text and you want to edit across multiple lines. There's a solution for that!"
              onSave={this.handleSuccess}
              type="textarea"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <InlineEdit
              name="validationValue"
              label="Don't enter test"
              value={this.state.validationValue}
              validateInput={this.validateText}
              onSave={this.handleSuccess}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <InlineEdit name="sizeValue" size="h2" value={this.state.sizeValue} onSave={this.handleSuccess} />
          </div>
        </div>
      </>
    );
  }
}
